<template>
  <div v-if="loaded" class="main-container">
    <div class="video-container mt-5">
      <div class="content-container">
        <div v-if="!playing && !finished" class="content-text-container">
          <h4 id="video-title">
            {{ $helpers.translate(content.content.title, lang) }}
          </h4>
          <p>{{ $helpers.translate(content.content.description, lang) }}</p>
        </div>
      </div>
      <div class="close-container">
        <CButton class="text-white" @click="onClose">
          <font-awesome-icon :icon="['fas', 'times']" />
        </CButton>
      </div>
      <div class="play-container">
        <CButton v-if="finished" color="success" @click="nextAction"
          >ต่อไป</CButton
        >

        <CButton
          v-if="!playing && !finished"
          @click="onStart"
          class="text-white"
        >
          <i id="play-icon">
            <font-awesome-icon :icon="['fas', 'play']" />
          </i>
          &nbsp;{{ $helpers.translate(content.content.note, lang) }}
        </CButton>
        <CButton
          v-if="playing && !finished"
          @click="onPause"
          class="text-white"
        >
          <font-awesome-icon :icon="['fas', 'pause-circle']" />&nbsp;Pause
        </CButton>
      </div>
      <video ref="video" @ended="onFinish">
        <source :src="videoURL" type="video/mp4" />
      </video>
      <div v-if="finished" class="video-link-container">
        <div v-for="(item, index) in ref" :key="index" class="video-thumb">
          <a
            :href="item.link"
            target="blank"
            v-bind:style="{
              backgroundImage: 'url(' + baseUrl + 'cpr/Image/' + item.img + ')',
            }"
          ></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      lessonNumber: 1,
      lang: "th",
      topicId: "",
      content: [],
      courseCode: "",
      courseSection: 0,
      startTime: "",
      playing: false,
      videoURL: null,
      finished: false,
      loaded: false,
      baseUrl: process.env.VUE_APP_URL_SOUND,
      courseCodeIdParams: "",
      paticipationId: "",
      ref: [
        {
          img: "new1.png",
          link:
            "https://today.line.me/th/v2/article/CPR+%E0%B9%80%E0%B8%82%E0%B9%89%E0%B8%B2%E0%B9%84%E0%B8%A1%E0%B9%88%E0%B8%96%E0%B8%B6%E0%B8%87%E0%B8%84%E0%B8%99%E0%B9%84%E0%B8%97%E0%B8%A2+%E0%B8%9B%E0%B8%B1%E0%B9%8A%E0%B8%A1%E0%B8%AB%E0%B8%B1%E0%B8%A7%E0%B9%83%E0%B8%88%E0%B8%9C%E0%B8%B4%E0%B8%94%E0%B8%9B%E0%B8%A5%E0%B8%B4%E0%B8%94%E0%B8%8A%E0%B8%B5%E0%B8%A7%E0%B8%B4%E0%B8%95+%E2%80%9C%E0%B9%82%E0%B8%88+%E0%B8%9A%E0%B8%AD%E0%B8%A2%E0%B8%AA%E0%B9%80%E0%B8%81%E0%B9%8A%E0%B8%B2%E0%B8%97%E0%B9%8C%E2%80%9D-RQDzye",
        },
        {
          img: "new2.png",
          link: "https://www.thairath.co.th/news/society/1211303",
        },
        {
          img: "new3.png",
          link: "https://www.thairath.co.th/news/society/1780120",
        },
        {
          img: "new4.png",
          link: "https://www.thairath.co.th/news/society/1626851",
        },
        {
          img: "new5.png",
          link: "https://www.youtube.com/watch?v=5TeJHo6JjGY",
        },
        {
          img: "new6.png",
          link: "https://www.thairath.co.th/news/society/1419251",
        },
        {
          img: "new7.png",
          link: "https://news.mthai.com/social-news/562398.html",
        },
        {
          img: "new8.png",
          link: "https://news.mthai.com/general-news/580780.html",
        },
        {
          img: "new9.png",
          link: "https://www.youtube.com/watch?v=VPKaFg-iNUc",
        },
        {
          img: "new10.png",
          link: "https://news.thaipbs.or.th/content/272936",
        },
      ],
    };
  },
  mounted() {
    let body = {};
    body.code = this.courseCode;
    body.templateCode = "CPR-E1";
    this.$store.dispatch("template/fetchContent", body);
    // this.$store.dispatch("courses/fetchCourseTopic", this.courseCode);
  },
  created() {
    this.courseCode = this.$store.getters["necessary/getLerningCourse"]._id;
    this.startTime = this.$helpers.getDateFormat();
  },
  computed: {
    ...mapGetters({
      videoContent: "template/getTemplateContent",
      courseTopicID: "courses/getCourseTopicID",
      getTemplateCriteria: "template/getUserTemplate",
      loadingGetter: "template/loadingGetter",
    }),
  },
  watch: {
    courseTopicID: function (val) {
      this.topicId = this.$helpers.getTopicIDByNumber(
        val.topics,
        this.lessonNumber
      );
    },
    videoContent: function (val) {
     
      if(!val.enable){
        this.$router.push({name: val.navigate.close.action});
      }else{
        this.content = val;
        
        this.videoURL =
          this.baseUrl + "/cpr/Video/" + this.content.content.item[0].data;
        this.loaded = true;
        this.courseSection = this.$store.getters[
          "necessary/getLerningCourse"
        ].groups[0].code;
      
        this.$store.dispatch("template/createUserTemplateData", {
          code: this.courseCode,
          template: val._id,
          section: this.courseSection,
        });
        
      }
    },
    getTemplateCriteria: function (val) {
      val.data.condition.criteriaType.filter((item, index) => {
        if (
          this.$helpers.translate(item.criteria.name, "en") == "paticipation"
        ) {
          this.paticipationId  = item.criteria._id
        }
      });
    },
    loadingGetter: function (val) {

     
    },
  },
  methods: {
    onStart() {
      this.playing = true;
      this.$refs.video.play();
    },
    onPause() {
      this.playing = false;
      this.$refs.video.pause();
    },
    onClose() {
      this.$router.push({
        path: "/CPR/preview/" + this.content.navigate.previous.action,
      });
    },
    onFinish() {
      this.finished = true;
      this.playing = false;
    },
    nextAction() {
      const useTime = this.$helpers.getUseTime();
      this.$store.dispatch("template/saveUserTemplateData", {
        code: this.courseCode,
        template: this.content._id,
        section: this.courseSection,
        answering: [],
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        condition: [
          {
            criteria: this.paticipationId, // การวัดผลด้านต่างๆ
            val: 100,
          },
        ],
      });
      this.$router.push({
        name: "CPRSummary",
        params: {
          id: "CPR-SUM01",
        },
      });
    },
  },
};
</script>
<style scoped>
@import "../../assets/scss/CPR/style.scss";
video {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
#video-title {
  text-transform: uppercase;
}
#play-icon {
  text-align: center;
  line-height: 30px;
  display: inline-block;
  margin-right: 10px;
  border: 1px solid #fff;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 12px;
}
.main-container {
  overflow-y: hidden;
  height: 100%;
}

.video-container {
  position: relative;
  width: 100%;
  height: 100%;
  /*border: 2px solid black;*/
}

.showing-border-top {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 2vh;
  z-index: 9999;
  border-top: 3.5rem solid black;
}

.showing-border-bottom {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2vh;
  z-index: 9999;
  border-bottom: 3.5rem solid black;
}

.content-container {
  color: white;
  text-align: justify;
  position: absolute;
  width: 240px;
  bottom: 4rem;
  left: 3rem;
}
.close-container {
  color: white;
  text-align: justify;
  position: absolute;
  top: 15%;
  right: 5%;
  z-index: 9;
}

.play-container {
  color: #FFF;
  position: absolute;
  right: 3rem;
  bottom: 15%;
  z-index: 99;
}
.video-link-container {
  position: absolute;
  z-index: 99;
  bottom: 2%;
  width: 100%;
  text-align: center;
}
.video-thumb {
  width: 80px;
  height: 60px;
  background: #666;
  mix-blend-mode: multiply;
  opacity: 1;
  display: inline-block;
  margin: 3px;
  border-bottom: 3px solid #CCCCCC;
  cursor: pointer;
}
@media screen and (min-width: 1440px) {
  .video-thumb {
    width: 120px;
    height: 90px;
  }
}
.video-thumb a {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  display: block;
}
.video-thumb:hover {
  border-width: 1px 1px 3px 1px;
  border-color: #BF2642;
  border-style: solid;
}
.button-container {
  z-index: 0;
  color: white;
  text-align: justify;
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.button-container:hover {
  cursor: pointer;
  color: red;
}
</style>
